// This file was automatically generated from ptdata.careTeamProviders.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.careTeamProviders');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.careTeamProviders');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.careTeamProviders.refpanelSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p><a class="care-team-summary-list-trigger">');
  if (opt_data.specialtyCategories.length) {
    var cList18503 = opt_data.specialtyCategories;
    var cListLen18503 = cList18503.length;
    for (var cIndex18503 = 0; cIndex18503 < cListLen18503; cIndex18503++) {
      var cData18503 = cList18503[cIndex18503];
      output.append('<span class="mr5 el8333 el8Bold">');
      el8.template.ptdata.careTeamProviders.abbreviation({category: cData18503}, output);
      output.append('</span>');
    }
  }
  output.append((opt_data.physician.isPcp) ? '(PCP) ' : '', soy.$$escapeHtml(opt_data.physician.fullName), (opt_data.isCurrentUser) ? ' (you)' : (opt_data.isPracticeUser) ? ' (in your practice)' : '', '</a>', (opt_data.physician.phone) ? '<span class="ml5">(T) ' + soy.$$escapeHtml(opt_data.physician.phone) + '</span>' : '', '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.careTeamProviders.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.specialtyCategories.length) {
    el8.template.ptdata.careTeamProviders.specialtyCategoryAbbreviations(opt_data, output);
    output.append(': ');
  }
  output.append(soy.$$escapeHtml(opt_data.physician.fullName), (opt_data.note) ? ' (' + soy.$$escapeHtml(opt_data.note) + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.careTeamProviders.abbreviation = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.category.abbreviation) ? soy.$$escapeHtml(opt_data.category.abbreviation) : soy.$$escapeHtml(opt_data.category.name.substring(0,4))? soy.$$escapeHtml(opt_data.category.name.substring(0,4)).toUpperCase() : '');
  if (!opt_sb) return output.toString();
};
